import * as _ from 'lodash';
import {createSelector} from "reselect";
import {getHints, IHint} from "../../data/data";
import {getYearIndex} from './year';


/**
 * get the hints for the current year
 */
export const getHintData = createSelector(

    [getYearIndex],

    (year_index: number) : IHint =>
    {
        const hints: IHint[] = getHints();

        return hints[year_index];
    }
);



// WEBPACK FOOTER //
// ./src/ts/store/reducers/hint.ts